<template>
    <div class="login">
        <div class="login-form">
            <!-- <a-button type="link" class="back-button" @click="onBack">
                <span>Назад</span>
            </a-button> -->

            <h1>Установите новый пароль</h1>

            <a-form
                ref="formRef"
                :model="formState"
                :rules="formValidationRules"
                @finish="onSubmit"
            >
                <a-form-item
                    name="password"
                    label="Пароль"
                >
                    <a-input-password
                        v-model:value="formState.password"
                        :class="{ 'invalid': !rules.length && formState.password }"
                        placeholder="Пароль"
                        @input="validatePassword"
                    />
                </a-form-item>

                <a-form-item
                    name="confirmPassword"
                    label="Подтверждение"
                >
                    <a-input-password
                        v-model:value="formState.confirmPassword"
                        :class="{ 'invalid': !rules.match && formState.confirmPassword }"
                        placeholder="Подтверждение"
                        @input="validatePassword"
                    />
                </a-form-item>

                <div class="password-rules">
                    <h4>Пароль должен иметь:</h4>
                    <ul>
                        <li :class="{ 'valid': rules.length }">
                            <span class="icon">{{ rules.length ? '✅' : '❌' }}</span>
                            Длину не меньше 12 символов
                        </li>
                        <li :class="{ 'valid': rules.uppercase }">
                            <span class="icon">{{ rules.uppercase ? '✅' : '❌' }}</span>
                            Прописные буквы английского алфавита от A до Z
                        </li>
                        <li :class="{ 'valid': rules.lowercase }">
                            <span class="icon">{{ rules.lowercase ? '✅' : '❌' }}</span>
                            Строчные буквы английского алфавита от a до z
                        </li>
                        <li :class="{ 'valid': rules.digits }">
                            <span class="icon">{{ rules.digits ? '✅' : '❌' }}</span>
                            Цифры от 0 до 9
                        </li>
                        <li :class="{ 'valid': rules.special }">
                            <span class="icon">{{ rules.special ? '✅' : '❌' }}</span>
                            Специальные символы ! ? @ # $ % ^ & * ( ) - _ + = ; : , . / \ |
                        </li>
                        <li :class="{ 'valid': rules.match }">
                            <span class="icon">{{ rules.match ? '✅' : '❌' }}</span>
                            Подтверждение
                        </li>
                    </ul>
                </div>

                <a-form-item>
                    <a-button
                        type="primary"
                        html-type="submit"
                        :disabled="!isFormValid || isLoading"
                        :loading="isLoading"
                        class="save-btn"
                    >
                        Сохранить
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
        <app-version />
    </div>
</template>

<script>
import { showErrorNotification, RouterConfig } from '@/utils';
import AppVersion from '@/components/authorization/AppVersion.vue';

export default {
    name: 'AuthorizationForgotPasswordUp',
    components: {
        AppVersion,
    },
    data() {
        return {
            formState: {
                password: '',
                confirmPassword: '',
            },
            formValidationRules: {
                password: [
                    { required: true, message: 'Обязательное поле' },
                ],
                confirmPassword: [
                    { required: true, message: 'Обязательное поле' },
                ],
            },
            isLoading: false,
            rules: {
                length: false,
                uppercase: false,
                lowercase: false,
                digits: false,
                special: false,
                match: false,
            },
        };
    },
    computed: {
        isFormValid() {
            return Object.values(this.rules).every((rule) => rule === true);
        },
    },
    methods: {
        validatePassword() {
            const { password, confirmPassword } = this.formState;

            // Проверяем каждое правило
            this.rules.length = password.length >= 12;
            this.rules.uppercase = /[A-Z]/.test(password);
            this.rules.lowercase = /[a-z]/.test(password);
            this.rules.digits = /[0-9]/.test(password);
            this.rules.special = /[!@#$%^&*()\-_+=;:,./\\|?]/.test(password);
            this.rules.match = password === confirmPassword && confirmPassword !== '';
        },
        async onSubmit() {
            try {
                this.isLoading = true;

                const response = await this.$http.post('/v2/auth/forgot/reset', {
                    newPassword: this.formState.password,
                    confirmPassword: this.formState.confirmPassword,
                });

                const { user = {} } = response.data;

                if (Object.keys(user).length) {
                    const {
                        name,
                        previewFileId,
                        clinics,
                        id,
                        chatUserId,
                        chatUserToken,
                    } = user || {};

                    localStorage.username = name;
                    localStorage.previewFileId = previewFileId;
                    localStorage.clinics = clinics;
                    localStorage.staffId = id;
                    localStorage.chatUserId = chatUserId;
                    localStorage.chatUserToken = chatUserToken;
                }

                this.$router.push({
                    name: RouterConfig.loginPinUp.name,
                    query: { isForgotReset: 'true' },
                });
            } catch (error) {
                if (error.response?.data?.msg) {
                    showErrorNotification(error.response.data.msg, 5000);
                } else {
                    showErrorNotification('Не удалось сбросить пароль', 5000);
                }
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.login {
    background: url("/images/login-wall.jpg") center center / cover no-repeat rgb(255, 255, 255);
    height: 100%;
    display: flex;
}

.login-form {
    position: relative;
    margin: auto;
    max-width: 460px;
    min-height: 330px;
    width: 100%;
    border-radius: 8px;
    border: none;
    padding: 26px;
    background-color: transparent;
    z-index: 1;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-color: #fff;
        opacity: 0.8;
        z-index: -1;
    }

    h1 {
        font-size: 26px;
        font-weight: bold;
        margin-bottom: 8px;
        text-align: center;
    }

    &:deep(.ant-form-item:last-child) {
        margin-block: 0;
    }

    &:deep(.ant-form-item-label > label) {
        text-align: left;
        font-size: 14px;
        color: #666;
    }

    .ant-input-password {
        border: 1px solid #d9d9d9;
        border-radius: 4px;

        &:hover {
            border-color: #83b274;
        }

        &:has(input:focus) {
            border-color: #83b274;
            box-shadow: 0 0 0 2px rgb(131, 178, 116, 0.2);
        }

        &.invalid {
            border-color: #ff4d4f;
            box-shadow: 0 0 0 2px rgba(255, 77, 77, 0.2);
        }
    }

    .password-rules {
        margin-bottom: 20px;

        h4 {
            font-size: 14px;
            margin-bottom: 10px;
            color: #666;
        }

        ul {
            list-style: none;
            padding: 0;

            li {
                padding: 4px 0;
                font-size: 14px;
                color: #666;
                display: flex;
                align-items: center;

                .icon {
                    margin-right: 8px;
                    font-size: 16px;
                    width: 20px;
                    text-align: center;
                }

                &.valid {
                    color: #52c41a;
                    .icon {
                        color: #52c41a;
                    }
                }
            }
        }
    }

    .save-btn {
        min-width: 110px;
        width: fit-content;
        height: auto;
        font-size: 14px;
        padding: 7px 20px;
        background-color: #8dc07c;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 0px 4px rgba(46, 75, 37, 0.4);
        border: none;
        color: #fff;

        &:disabled,
        &[disabled] {
            pointer-events: none;
            opacity: 0.5;
        }

        &:hover {
            background-color: #74b85d;
        }

        &:focus {
            outline: none;
            box-shadow: 0 0 0 2px rgba(139, 195, 74, 0.2) !important;
        }
    }

    .back-button {
        position: absolute;
        top: 10px;
        left: 10px;
        padding: 0;
        font-size: 16px;
        color: #666;
    }
}
</style>
